import { render, staticRenderFns } from "./elementTable.vue?vue&type=template&id=595935b0&scoped=true&"
import script from "./elementTable.vue?vue&type=script&lang=js&"
export * from "./elementTable.vue?vue&type=script&lang=js&"
import style0 from "./elementTable.vue?vue&type=style&index=0&id=595935b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595935b0",
  null
  
)

export default component.exports